export default "__VITE_ASSET__CWZDlAcg__"